import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { default as RFRLink, NavLink as RFRNavLink } from 'redux-first-router-link';

import 'css/ui/Link.css';




const Link = (props) => {

	const {
		// A route name, or an external URL.
		to,
		// Dynamic route parameters. Used as payload for dispatched route actions.
		params,
		// Alternative `to` prop used specifically for URLs (internal or external).
		// The primary use case for this is markdown generated links that rely on a component accepting an href.
		href,
		// Set to true to have a .link--active class added while the route is active.
		// Also renders a <NavLink>, meaning those additional props are available:
		// https://github.com/faceyspacey/redux-first-router-link#react-router-navlink-only-props
		nav,
		// Set to true for external links (renders plain <a> element with safety attributes).
		external,
		// Render link as a block element.
		block,
		// Special style for use on dark backgrounds.
		light,
		// Removes application-default link styles, opening up styling potential without requiring overrides.
		customStyle,
		// Class string to pass through.
		className,
		// Link content.
		children,
		// Any other properties are passed to underlying component.
		...otherProps
	} = props;


	let LinkComponent = RFRLink;

	// Auto-mark URLs beginning with "http" as external.
	// If necessary, regex URL detection can be used.
	const isExternal = external ||
	                   (href && href.indexOf('http') === 0) ||
	                   (typeof to === 'string' && to.indexOf('http') === 0);

	if (isExternal) {
		LinkComponent = 'a';
	} else if (nav) {
		LinkComponent = RFRNavLink;
	}


	const linkClass = classNames('link', className, {
		block,
		'link--standard': !customStyle,
		'link--light': light
	});


	// The passed props can differ based on component type, so we'll dynamically generate them.
	const linkProps = {};

	if (isExternal) {
		linkProps.href = to || href;
		linkProps.target = '_blank';
		linkProps.rel = 'noopener noreferrer';
	} else {
		if (href) {
			linkProps.to = href;
		} else {
			linkProps.to = { type: to, payload: params };
		}
	}

	if (nav) {
		linkProps.activeClassName = 'link--active';
	}

	return (
		<LinkComponent className={linkClass} {...linkProps} {...otherProps}>
			{children}
		</LinkComponent>
	);
};


export default Link;


Link.propTypes = {
	to: PropTypes.string,
	params: PropTypes.object,
	href: PropTypes.string,
	nav: PropTypes.bool,
	external: PropTypes.bool,
	block: PropTypes.bool,
	light: PropTypes.bool,
	customStyle: PropTypes.bool,
	className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/ui/Link.jsx